import React, { createContext, useContext, useEffect, useState } from 'react';
import { supabase } from '../supabaseClient';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSession = async () => {
      const { data: { session }, error } = await supabase.auth.getSession();
      console.log('[AuthContext] getSession result:', { session, error });

      if (error) {
        console.error('[AuthContext] Error fetching session:', error);
        setLoading(false);
        return;
      }

      if (session?.user) {
        setUser(session.user);
        console.log('[AuthContext] Session user:', session.user);

        const { data: profileData, error: profileError } = await supabase
          .from('users')
          .select('*')
          .eq('id', session.user.id)
          .single();
        console.log('[AuthContext] Profile fetch result:', { profileData, profileError });

        if (profileError) {
          console.error('[AuthContext] Error fetching user profile:', profileError);
        } else {
          console.log('[AuthContext] Profile loaded:', profileData);
          setProfile(profileData);
        }
      } else {
        console.warn('[AuthContext] No session user found.');
      }

      setLoading(false);
    };

    fetchSession();

    const { data: authListener } = supabase.auth.onAuthStateChange((_event, session) => {
      console.log('[AuthContext] onAuthStateChange event:', _event, session);
      if (session?.user) {
        setUser(session.user);
        console.log('[AuthContext] onAuthStateChange user:', session.user);
        supabase
          .from('users')
          .select('*')
          .eq('id', session.user.id)
          .single()
          .then(({ data: profileData, error: profileError }) => {
            console.log('[AuthContext] onAuthStateChange profile fetch:', { profileData, profileError });
            if (profileError) {
              console.error('[AuthContext] Error fetching user profile (onAuthStateChange):', profileError);
            } else {
              console.log('[AuthContext] Profile loaded (onAuthStateChange):', profileData);
              setProfile(profileData);
            }
          });
      } else {
        setUser(null);
        setProfile(null);
        console.warn('[AuthContext] onAuthStateChange: No user, cleared profile.');
      }
    });

    return () => {
      authListener?.subscription?.unsubscribe();
    };
  }, []);

  return (
    <AuthContext.Provider value={{ user, profile, loading }}>
      {!loading && children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);

export { AuthContext };

export default useAuth;